import {Box, Grid, Stack, Typography, useTheme} from '@mui/material';
import {CardType, E_QuickLinks, IArtifact, PinTypes} from 'app/types/Shared';
import {ArtifactCards} from 'components/ArtifactCards';
import {PinFilled} from '@carbon/icons-react';
import {useSelector} from 'react-redux';
import {selectAllArtifacts} from 'app/store/artifacts/artifactSlice';
import {selectAllProcesses} from 'app/store/operatingModel/operatingModelSlice';

type PageProps = {
  type: string;
  data: Array<IArtifact>;
};

const ArtifactQuickLink = ({type, data}: PageProps) => {
  const allArtifacts = useSelector(selectAllArtifacts);
  const allProcesses = useSelector(selectAllProcesses);

  const processes = data.filter((artifact) => artifact.type === PinTypes.Process);
  const documents = data.filter((artifact) => artifact.type !== PinTypes.Process);

  const validProcesses = processes.filter((process) => {
    return allProcesses?.some((p) => p.process_id === process.key);
  });
  const validDocuments = documents.filter((document) => {
    return allArtifacts?.some((a) => a.key === document.key);
  });
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        pl: 6,
        pr: 2,
        pt: 2,
        pb: 4,
        background: theme.palette.grey[100],
        minHeight: '79vh',
        borderTop: `1px solid ${theme.palette.grey[500]}`,
      }}
    >
      <Grid container rowGap={'20px'} columnGap={'20px'}>
        <Grid item direction='row' xs={12} md={12} lg={8} xl={5.7}>
          <Grid item xs={12} pb={2}>
            <Typography variant='h5'>{`${type} Processes`}</Typography>
          </Grid>
          {validProcesses?.length === 0 && type === E_QuickLinks.Pinned ? (
            <Stack direction='column' spacing={1} pt={2}>
              <Stack direction='row' spacing={1}>
                <PinFilled fill={theme.palette.primary.main} />
                <Typography variant='h5'>Nothing pinned yet.</Typography>
              </Stack>

              <Typography variant='h6'>
                When you click the pushpin icon on a process tile or process page, it’ll show up here.
              </Typography>
            </Stack>
          ) : (
            <Grid item container xs={12} spacing={1}>
              {validProcesses?.map((item) => (
                <Grid item xs={12} md={12} lg={6} key={item.key}>
                  <Box maxWidth='340px'>
                    <ArtifactCards
                      data={{
                        ...item,
                        card: CardType.process,
                        created_dt: item.created_dt?.substring(0, 10),
                      }}
                    />
                  </Box>
                </Grid>
              ))}
            </Grid>
          )}
        </Grid>
        <Grid item xs={12} md={12} lg={8} xl={6.1}>
          <Grid item xs={12} pb={2}>
            <Typography variant='h5'>{`${type} Documents`}</Typography>
          </Grid>
          {validDocuments?.length === 0 && type === E_QuickLinks.Pinned ? (
            <Stack direction='column' spacing={1} pt={2}>
              <Stack direction='row' spacing={1}>
                <PinFilled fill={theme.palette.primary.main} />
                <Typography variant='h5'>Nothing pinned yet.</Typography>
              </Stack>

              <Typography variant='h6'>
                When you click the pushpin icon on a document tile, it’ll show up here.
              </Typography>
            </Stack>
          ) : (
            <Grid item container xs={12} spacing={1}>
              {validDocuments?.map((item) => (
                <Grid item xs={12} sm={12} md={12} lg={6} key={item.key}>
                  <ArtifactCards
                    key={item.key}
                    data={{
                      ...item,
                      card: CardType.document,
                      created_dt: item.created_dt?.substring(0, 10),
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
export default ArtifactQuickLink;
